import { useCallback } from 'react';

import Dialog from '@/components/Dialog';
import config from '@/config';

interface UpgradeRequiredDialogProps {
  open: boolean;
  feature: string;
  onClose: () => void;
}

export function UpgradeRequiredDialog({
  open,
  feature,
  onClose,
}: UpgradeRequiredDialogProps): JSX.Element {
  const handleTalkToSales = useCallback(() => {
    window.open(config.calendlyUrl, '_blank', 'noopener,noreferrer');
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      title="Upgrade to proceed"
      subTitle={<p>{feature} require a plan upgrade. Talk to our sales team to get started.</p>}
      confirmLabel="Talk to Sales"
      cancelLabel="Dismiss"
      onConfirm={handleTalkToSales}
      onCancel={onClose}
    />
  );
}
